module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/icon_ham_24x24_open.98b97aca.svg";